/* Homepage redesign behaviour: hero slider, product carousels (arrows +
   optional re-sort via the Section Rendering API), today's hours. */
(function () {
  if (window.__homeRedesignInit) return;
  window.__homeRedesignInit = true;

  function initSlider(root) {
    if (root.__init) return; root.__init = true;
    var slides = root.querySelectorAll('.home-hero__slide');
    var dots = root.querySelectorAll('[data-slide-to]');
    if (slides.length < 2) return;
    var i = 0, timer = null, interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { var on = k === i; s.classList.toggle('is-active', on); s.setAttribute('aria-hidden', on ? 'false' : 'true'); if (s.tagName === 'A') s.tabIndex = on ? 0 : -1; s.querySelectorAll('a').forEach(function (a) { a.tabIndex = on ? 0 : -1; }); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function start() { if (reduce) return; stop(); timer = setInterval(function () { show(i + 1); }, interval); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    dots.forEach(function (d) { d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-slide-to'), 10)); start(); }); });
    var p = root.querySelector('[data-slide-prev]'), n = root.querySelector('[data-slide-next]');
    if (p) p.addEventListener('click', function () { show(i - 1); start(); });
    if (n) n.addEventListener('click', function () { show(i + 1); start(); });
    root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop); root.addEventListener('focusout', start);
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) show(dx < 0 ? i + 1 : i - 1); start();
    }, { passive: true });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    show(0); start();
  }

  function initCarousel(root) {
    if (root.__init) return; root.__init = true;
    var track = root.querySelector('[data-carousel-track]');
    var prev = root.querySelector('[data-carousel-prev]'), next = root.querySelector('[data-carousel-next]');
    if (!track) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    function step(dir) { track.scrollBy({ left: dir * Math.max(track.clientWidth * 0.8, 200), behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();

    var url = root.getAttribute('data-sort-url');
    if (!url || !window.fetch) return;
    var sid = root.getAttribute('data-section-id');
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 12;
    var hideSoldOut = root.getAttribute('data-hide-sold-out') === 'true';
    var excludeTag = (root.getAttribute('data-exclude-tag') || '').trim();
    var keepQuick = !!track.querySelector('.quick-add');
    track.classList.add('is-loading');
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (data) {
        var html = data && data['home-carousel-feed'];
        if (!html) throw new Error('empty');
        html = html.split('home-carousel-feed').join(sid);
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = Array.prototype.slice.call(doc.querySelectorAll('li.home-carousel__item'));
        if (hideSoldOut) items = items.filter(function (li) { return li.getAttribute('data-available') !== 'false'; });
        if (excludeTag) items = items.filter(function (li) { return (li.getAttribute('data-tags') || '').split('|').indexOf(excludeTag) === -1; });
        items = items.slice(0, limit);
        if (items.length < Math.min(limit, 4)) throw new Error('too few');
        var frag = document.createDocumentFragment();
        items.forEach(function (li) {
          if (!keepQuick) li.querySelectorAll('.quick-add').forEach(function (q) { q.remove(); });
          frag.appendChild(document.importNode(li, true));
        });
        track.innerHTML = '';
        track.appendChild(frag);
        track.scrollLeft = 0;
      })
      .catch(function () { /* keep the server-rendered collection order */ })
      .then(function () { track.classList.remove('is-loading'); update(); });
  }

  function initHours(root) {
    if (root.__init) return; root.__init = true;
    var tz = root.getAttribute('data-tz') || 'America/Toronto', parts;
    try {
      parts = new Intl.DateTimeFormat('en-US', { timeZone: tz, weekday: 'long', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
    } catch (e) { return; }
    var get = function (t) { var p = parts.find(function (x) { return x.type === t; }); return p ? p.value : ''; };
    var today = get('weekday').toLowerCase();
    var minutes = (parseInt(get('hour'), 10) % 24) * 60 + parseInt(get('minute'), 10);
    var row = null;
    root.querySelectorAll('[data-day]').forEach(function (li) { if (li.getAttribute('data-day').trim().toLowerCase() === today) row = li; });
    if (!row) return;
    row.classList.add('is-today');
    var status = root.querySelector('[data-hours-status]'), text = root.querySelector('[data-hours-status-text]');
    if (!status || !text) return;
    var hours = row.getAttribute('data-hours').trim();
    var toMin = function (h, m, ap) { h = parseInt(h, 10) % 12; if (ap.toLowerCase() === 'pm') h += 12; return h * 60 + parseInt(m || '0', 10); };
    var m = hours.match(/(\d{1,2})(?::(\d{2}))?\s*(am|pm)\s*[-–]\s*(\d{1,2})(?::(\d{2}))?\s*(am|pm)/i);
    if (m) {
      var open = toMin(m[1], m[2], m[3]), close = toMin(m[4], m[5], m[6]);
      var isOpen = minutes >= open && minutes < close;
      status.classList.add(isOpen ? 'is-open' : 'is-closed');
      text.textContent = isOpen
        ? root.getAttribute('data-open-label') + ' · ' + root.getAttribute('data-opens-label') + ' ' + hours
        : root.getAttribute('data-closed-label') + ' · ' + root.getAttribute('data-opens-label') + ' ' + hours;
      status.hidden = false;
    } else if (/closed/i.test(hours)) {
      status.classList.add('is-closed');
      text.textContent = root.getAttribute('data-closed-today-label');
      status.hidden = false;
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-home-slider]').forEach(initSlider);
    (scope || document).querySelectorAll('[data-home-carousel]').forEach(initCarousel);
    (scope || document).querySelectorAll('[data-home-hours]').forEach(initHours);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
